export default __webpack_public_path__ + "static/appstore-50163ae0d1021aa1128ca79f924a17c9.svg";